;(function () {
  angular
    .module('contrast.organization-info')
    .controller(
      'OrganizationInfoCtrl',
      function (
        $scope,
        logger,
        GlobalFactory,
        OrganizationFactory,
        ErrorService,
        ProfileService,
        OrganizationService,
        pendoService
      ) {
        'ngInject'

        var originalOrganization = {}

        var expandValue = 'auto_license,beta_languages'

        $scope.organization = {}
        $scope.time_zones = []
        $scope.time_formats = []
        $scope.date_formats = []

        $scope.administrators = []
        $scope.adminsLimitTo = 6

        angular.extend($scope, {
          model: {}
        })

        angular.extend($scope, {
          toggleLocaleChange: toggleLocaleChange,
          checkPendo: checkPendo
        })

        function checkPendo() {
          pendoService.initialize(ProfileService.getUser(), $scope.organization)
        }

        function init() {
          loadOrganization()
        }

        function loadOrganization() {
          return OrganizationFactory.getOrganizationExpand(expandValue)
            .then(function (response) {
              originalOrganization = OrganizationService.buildOrganization(
                response.data.organization
              )
              $scope.organization = angular.copy(originalOrganization)
              loadTimeZones()
              loadDateFormats()
              loadTimeFormats()

              loadAdministrators()

              $scope.model.locale =
                response.data.organization.locale !== 'es'
                  ? response.data.organization.locale
                  : 'en'
            })
            .catch(ErrorService.processError)
        }

        function loadAdministrators() {
          OrganizationFactory.getAdministrators().then(
            function (response) {
              $scope.administrators = response.data.administrators
            },
            function (response) {
              ErrorService.processError(response)
            }
          )
        }

        function loadTimeZones() {
          GlobalFactory.getTimeZones().then(
            function (response) {
              $scope.time_zones = response.data.timezones
              $scope.timezone = _.find($scope.time_zones, {
                name: $scope.organization.timezone
              })
            },
            function (response) {
              ErrorService.processError(response)
            }
          )
        }

        function loadDateFormats() {
          GlobalFactory.getDateFormats().then(
            function (response) {
              $scope.date_formats = response.data.date_formats
              $scope.date_format = _.find($scope.date_formats, {
                value: $scope.organization.date_format
              })
            },
            function (response) {
              ErrorService.processError(response)
            }
          )
        }

        function toggleLocaleChange(locale) {
          $scope.model.locale = locale
        }

        function loadTimeFormats() {
          GlobalFactory.getTimeFormats().then(
            function (response) {
              $scope.time_formats = response.data.time_formats
              $scope.time_format = _.find($scope.time_formats, {
                value: $scope.organization.time_format
              })
            },
            function (response) {
              ErrorService.processError(response)
            }
          )
        }

        $scope.editOrganization = function () {
          var form = {
            name: $scope.organization.name,
            timezone: $scope.organization.timezone,
            date_format: $scope.organization.date_format,
            time_format: $scope.organization.time_format,
            locale: $scope.model.locale
          }
          return OrganizationFactory.editOrganization(form).then(
            function (response) {
              logger.logSuccess(response.data.messages[0])
              originalOrganization = angular.copy($scope.organization)
              $scope.timezone = _.find($scope.time_zones, {
                name: $scope.organization.timezone
              })
              $scope.time_format = _.find($scope.time_formats, {
                value: $scope.organization.time_format
              })
              $scope.date_format = _.find($scope.date_formats, {
                value: $scope.organization.date_format
              })
            },
            function (response) {
              $scope.organization = angular.copy(originalOrganization)
              ErrorService.processError(response)
            }
          )
        }

        $scope.showAllAdmins = function () {
          $scope.adminsLimitTo = 'Infinity'
        }

        $scope.showAllAppsNearingExpiration = function () {
          $scope.assessment.limit = 'Infinity'
        }

        $scope.showAllServersNearingExpiration = function () {
          $scope.protection.limit = 'Infinity'
        }

        init()
      }
    )
})()
